import { z } from "zod";

export const communityTestimonialSchema = z.object({
	quote: z.string().min(1).max(500),
	author_name: z.string().min(1).max(100),
	author_role: z.string().max(100).optional(),
	author_avatar_url: z.url().nullable().optional(),
	order: z.number().int().min(0),
});

export type CommunityTestimonial = z.infer<typeof communityTestimonialSchema>;
